import { ReactNode, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

interface ShadowWrapperProps {
  children: ReactNode;
  styles?: string[];
}

export default function ShadowWrapper({
  children,
  styles = [],
}: ShadowWrapperProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const host = ref.current;
    if (!host) return;

    let shadow = host.shadowRoot;
    if (!shadow) {
      shadow = host.attachShadow({ mode: "open" });

      if (styles.length > 0) {
        const styleEl = document.createElement("style");
        styleEl.textContent = styles.join("\n");
        shadow.appendChild(styleEl);
      }

      const div = document.createElement("div");
      div.style.height = "100%";
      shadow.appendChild(div);

      setContainer(div);
    } else {
      const existingContainer =
        shadow.querySelector<HTMLDivElement>("#shadow-content");
      if (existingContainer) {
        setContainer(existingContainer);
      }
    }
  }, []);

  return (
    <div ref={ref} style={{ height: "100%" }}>
      {container ? createPortal(children, container) : null}
    </div>
  );
}
